import React from "react";
import store from "src/store";
import { cardTitleStyle } from "./card-styles";
import InputDatepicker from "./input-datepicker";
import InputDropdown from "./input-dropdown";
import Button from "./button";
import { exportIcon } from "./icons-svg";
import useIsLoggedIn from "src/utils/use-is-logged-in";

export default function AnalyticsFilter() {
    const { userInfo } = useIsLoggedIn();

    const getAllOrganizationList = () => {
        let organizationList = [];

        organizationList.push({
            label: 'All',
            value: 'All'
        });

        if (store.allAnalytics.length) {
            for (let i = 0; i < store.allAnalytics.length; i++) {
                if (
                    store.allAnalytics[i]['organizationData'] &&
                    organizationList.findIndex((item) => (item.value == store.allAnalytics[i].organizationData.name)) == -1
                ) {
                    organizationList.push({
                        label: store.allAnalytics[i].organizationData.name,
                        value: store.allAnalytics[i].organizationData.name
                    });
                }
            }
            return organizationList;
        } else {
            return organizationList;
        }
    }

    const getAllEngagementList = () => {
        return [
            {
                label: 'All',
                value: 'All'
            },
            {
                label: 'Public',
                value: 'Public'
            },
            {
                label: 'Private',
                value: ''
            }
        ];
    }

    const getAllReviewList = () => {
        let reviewList = [];

        reviewList.push({
            label: 'All',
            value: 'All'
        });

        if (store.allAnalytics.length) {
            for (let i = 0; i < store.allAnalytics.length; i++) {
                if (
                    reviewList.findIndex((item) => (item.value == store.allAnalytics[i].review_name)) == -1
                ) {
                    reviewList.push({
                        label: store.allAnalytics[i].review_name,
                        value: store.allAnalytics[i].review_name
                    });
                }
            }
            return reviewList;
        } else {
            return reviewList;
        }
    }

    const getAllUserList = () => {
        let userList = [];

        userList.push({
            label: 'All',
            value: 'All'
        })

        if (store.allAnalytics.length) {
            for (let i = 0; i < store.allAnalytics.length; i++) {
                if (
                    userList.findIndex((item) => (item.value == store.allAnalytics[i]['user_email'])) == -1
                ) {
                    userList.push({
                        label: store.allAnalytics[i]['user_email'],
                        value: store.allAnalytics[i]['user_email']
                    });
                }
            }
            return userList;
        } else {
            return userList;
        }
    }

    const getAllOperationList = () => {
        return [
            {
                label: 'All',
                value: 'All'
            },
            {
                label: 'Open',
                value: 'Open'
            },
            {
                label: 'Save',
                value: 'Save'
            },
            {
                label: 'Execute',
                value: 'Execute'
            },
            {
                label: 'CI Execution',
                value: 'CI Execution'
            }
        ]
    }

    return (
        <>
            <div css="display: flex; justify-content: space-between;">
                <div css="
                    display: flex; 
                    align-items: center;
                    width: 100%;
                    justify-content: start;
                ">
                    <div css="width: 15%; margin-right: 25px">
                        <InputDatepicker
                            id={"startDate"}
                            label={"Start Date"}
                            value={store.analyticsFilter.startDate}
                            disabled={false}
                            onChange={(value) => { store.updateAnalyticsFilter("startDate", value) }}
                            hasError={false}
                            errorText={''}
                        />
                    </div>
                    <div css="width: 15%; margin-right: 25px">
                        <InputDatepicker
                            id={"endDate"}
                            label={"End Date"}
                            value={store.analyticsFilter.endDate}
                            disabled={false}
                            onChange={(value) => { store.updateAnalyticsFilter("endDate", value) }}
                            hasError={false}
                            errorText={''}
                        />
                    </div>
                    {
                        !userInfo?.auth0Subscripton &&
                        <div css="width: 15%; margin-right: 25px">
                            <InputDropdown
                                id={"organization"}
                                label={"Filter by organization"}
                                value={store.analyticsFilter.organization}
                                disabled={false}
                                showClearOption={store.analyticsFilter.organization != 'All'}
                                onClear={() => { store.updateAnalyticsFilter('organization', 'All') }}
                                onChange={(value) => { store.updateAnalyticsFilter("organization", value) }}
                                list={getAllOrganizationList()}
                            />
                        </div>
                    }

                    <div css="width: 15%; margin-right: 25px">
                        <InputDropdown
                            id={"engagement"}
                            label={"Filter by engagements"}
                            value={store.analyticsFilter.engagement}
                            disabled={false}
                            showClearOption={store.analyticsFilter.engagement != 'All'}
                            onClear={() => { store.updateAnalyticsFilter('engagement', 'All') }}
                            onChange={(value) => { store.updateAnalyticsFilter("engagement", value) }}
                            list={getAllEngagementList()}
                        />
                    </div>
                    <div css="width: 15%; margin-right: 25px">
                        <InputDropdown
                            id={"review"}
                            label={"Filter by reviews"}
                            value={store.analyticsFilter.review}
                            disabled={false}
                            showClearOption={store.analyticsFilter.review != 'All'}
                            onClear={() => { store.updateAnalyticsFilter('review', 'All') }}
                            onChange={(value) => { store.updateAnalyticsFilter("review", value) }}
                            list={getAllReviewList()}
                        />
                    </div>
                    <div css="width: 15%; margin-right: 25px">
                        <InputDropdown
                            id={"user"}
                            label={"Filter by users"}
                            value={store.analyticsFilter.user}
                            disabled={false}
                            showClearOption={store.analyticsFilter.user != 'All'}
                            onClear={() => { store.updateAnalyticsFilter('user', 'All') }}
                            onChange={(value) => { store.updateAnalyticsFilter("user", value) }}
                            list={getAllUserList()}
                        />
                    </div>
                    <div css="width: 15%; margin-right: 25px">
                        <InputDropdown
                            id={"operation"}
                            label={"Filter by operations"}
                            value={store.analyticsFilter.operation}
                            disabled={false}
                            showClearOption={store.analyticsFilter.operation != 'All'}
                            onClear={() => { store.updateAnalyticsFilter('operation', 'All') }}
                            onChange={(value) => { store.updateAnalyticsFilter("operation", value) }}
                            list={getAllOperationList()}
                        />
                    </div>
                </div>
            </div>
            <div css="
                    width: 100%;
                ">
                <div css={cardTitleStyle + `;color:blue;cursor:pointer;text-decoration:underline;`}>
                    <span onClick={() => { store.clearAnalyticsFilter() }}>Clear filters</span>
                </div>
            </div>
            <div css="
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                ">
                <div>
                    <span>Showing result {store.analytics.length} out of {store.allAnalytics.length}</span>
                </div>
                <div>
                    {
                        store.analytics.length ?
                            <Button
                                onClick={() => {
                                    store.exportAnalytics()
                                }}
                                variant="text"
                                color="primary"
                                startIcon={exportIcon()}
                            >
                                Export CSV
                            </Button> : null
                    }

                </div>
            </div>
        </>
    )
}